export default __webpack_public_path__ + "static/media/prev-earbuddyzpro.6e95e0ed.jpg";